import React from 'react'
import { BrowserRouter, StaticRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

// When server rendering, we don't have a DOM and cannot use BrowserRouter, so we
// use StaticRouter when server rendering and then switch to BrowserRouter when we
// have a DOM (when we've mounted). This component abstracts those concerns.

class UniversalRouter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mounted: false,
    }
  }

  componentDidMount() {
    this.setState({ mounted: true })

    const { isMountedCallback } = this.props
    isMountedCallback(true)
  }

  render() {
    const { mounted } = this.state
    const Router = mounted ? BrowserRouter : StaticRouter
    return <Router {...this.props} />
  }
}

UniversalRouter.propTypes = {
  context: PropTypes.shape({}),
  isMountedCallback: PropTypes.func,
}

UniversalRouter.defaultProps = {
  context: {},
  isMountedCallback: (isMounted) => {},
}

export default UniversalRouter
